// tslint:disable: completed-docs
export const NAMESPACE = 'OVERLAY';
export const SET_TRACKING_STATE = 'overlayState';
export const GET_OVERLAY_CONTENT_FAILED = `${NAMESPACE}/GET_OVERLAY_CONTENT_FAILED`;
export const TRACK_OVERLAY = `${NAMESPACE}/TRACK_OVERLAY`;
